// extracted by mini-css-extract-plugin
module.exports = {"transcriptText":"ScriptSegment_transcriptText__fwVjP"};